import Blurhash from "@components/blurhash";
import { useIsEditorContext } from "@editor-providers";
import { useState } from "react";
import { getBlurhashFromUrl } from "@/shared";
import type { TMetadata } from "../types";
import { usePdfDetails } from "./pdf";

export const EmbeddedPreview = ({
  payload,
  isVisible,
}: {
  payload: TMetadata & { src: string };
  isVisible: boolean;
}) => {
  const isEditor = useIsEditorContext();
  const { shortUrl } = usePdfDetails();
  const {
    metaTitle,
    metaDescription,
    metaIcon,
    metaSiteName,
    metaDomain,
    metaImage,
    src,
  } = payload;

  const [loaded, setLoaded] = useState(false);
  const isDefaultOgImage = metaImage?.includes(
    "https://www.storydoc.com/assets/images/companies/",
  );

  const hash = getBlurhashFromUrl(src);

  const image = !isDefaultOgImage ? (
    <>
      {hash && !loaded && <Blurhash blurhash={hash} />}
      {isVisible && (
        <img
          src={metaImage}
          alt={metaTitle}
          onLoad={() => setLoaded(true)}
          className="!tw-absolute tw-left-0 tw-top-0 tw-block tw-h-full tw-w-full !tw-object-cover"
        />
      )}
    </>
  ) : (
    <div className="tw-absolute tw-left-0 tw-top-0 tw-flex tw-h-full tw-w-full tw-items-center tw-justify-center tw-bg-white">
      <img
        src={metaIcon}
        alt={metaTitle}
        className="!max-min-w-10 !tw-static !tw-h-auto !tw-w-[30%] !tw-max-w-16 !tw-object-contain"
      />
    </div>
  );

  return (
    <a
      href={src || shortUrl || "#"}
      target="_blank"
      rel="noreferrer"
      onClick={(e) => isEditor && e.preventDefault()}
      className="embedded-preview-cL5dyjnKIl tw-block tw-overflow-hidden tw-rounded-lg tw-border tw-border-solid tw-border-[#0d0d0d19] tw-bg-[#FAFAFA] !tw-no-underline"
    >
      <div className="tw-relative tw-flex tw-items-center tw-border-x-0 tw-border-b tw-border-t-0 tw-border-solid tw-border-b-blue-100">
        <div className="embedded-bg-cL5dyjnKIl tw-absolute tw-left-0 tw-top-0 tw-h-full tw-w-full tw-overflow-hidden after:tw-absolute after:tw-left-0 after:tw-top-0 after:tw-h-full after:tw-w-full after:tw-bg-black/70 after:tw-content-['']">
          <span className="tw-absolute tw-left-0 tw-top-0 tw-h-full tw-w-full tw-blur-md">
            {image}
          </span>
        </div>
        <div className="tw-relative tw-z-1 tw-w-full tw-pt-[56.25%]">
          {image}
        </div>
      </div>
      <div className="tw-relative tw-z-1 tw-px-4 tw-py-3">
        <p className="tw-m-0 tw-mb-1 tw-line-clamp-1 tw-text-left tw-text-[11px]/normal tw-font-semibold tw-text-[#0D0D0D] [font-family:var(--title-font)]">
          {metaTitle}
        </p>
        {metaDescription && (
          <p className="tw-m-0 tw-mb-3 tw-line-clamp-1 tw-text-left tw-text-[10px]/normal tw-font-normal tw-text-[#0D0D0D] [font-family:var(--paragraph-font)]">
            {metaDescription}
          </p>
        )}
        <div className="tw-flex tw-items-center tw-justify-between">
          <div className="tw-flex tw-items-center">
            <img
              src={metaIcon}
              alt={metaTitle}
              className="!tw-static !tw-mr-1 !tw-block !tw-h-auto !tw-w-3 !tw-object-contain"
            />
            <span className="tw-text-left tw-text-[8px]/normal tw-font-semibold tw-text-[#595959] [font-family:var(--paragraph-font)]">
              {metaDomain || metaSiteName}
            </span>
          </div>
          <i className="ri-external-link-line tw-text-xs tw-leading-none tw-text-[#808080]"></i>
        </div>
      </div>
    </a>
  );
};
